import {
    useCallback,
    useState,
    useMemo,
} from 'react'
import isNil from 'lodash/isNil'

import ConfirmationDialog from 'app/shared-components/ConfirmationDialog'
import DomainObjectForm from 'app/shared-components/DomainObjectForm'
import useValidation from 'app/hooks/useValidation'

import useStyles from './UploadCalibrationDocumentDialog.style'
import uploadDocFieldsConfig, {
    CalibrationItem,
} from './UploadCalibrationDocumentDialog.fields'

type Props = {
    onSuccess: (idDocument: number, calibratedOn: string) => void,
    open: boolean,
    onCancel: () => void,
}

const UploadCalibrationDocumentDialog = ({
    onSuccess,
    open,
    onCancel,
}: Readonly<Props>) => {
    const {
        classes,
    } = useStyles()
    const [
        formValues,
        setFormValues,
    ] = useState<CalibrationItem>({})

    const uploadAllowed = useMemo(() => {
        return isNil(formValues.attachment) || (formValues.attachment?.length < 1)
    }, [formValues.attachment])

    const uploadDocFields = uploadDocFieldsConfig(uploadAllowed)

    const onClose = useCallback((confirm) => {
        if (confirm) {
            onSuccess(formValues?.attachment?.[0].id, formValues.lastCalibratedOn)
        } else {
            onCancel()
        }
        setFormValues({}) // clean-up values
    }, [
        formValues,
        onSuccess,
        onCancel,
    ])

    const {
        isValid,
    } = useValidation({
        fields: uploadDocFields,
        values: formValues,
    })

    return (
        <ConfirmationDialog
            open={open}
            handleClose={onClose}
            dialogTitle="ADD CALIBRATION"
            positiveLabel="UPLOAD"
            negativeLabel="CANCEL"
            positiveLabelDisabled={!isValid}
            classNames={{
                content: classes.container,
            }}
        >
            <DomainObjectForm
                name="LoggerCalibrationsContainers"
                value={formValues}
                fields={uploadDocFields}
                className={classes.gridWrapper}
                onChange={setFormValues}
                wrapper="simple"
            />
        </ConfirmationDialog>
    )
}

export default UploadCalibrationDocumentDialog
